import { render, staticRenderFns } from "./SelectSender.vue?vue&type=template&id=59515377"
import script from "./SelectSender.vue?vue&type=script&lang=js"
export * from "./SelectSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports